"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var List_1 = __importDefault(require("../../../../List"));
var Item_1 = __importDefault(require("./Item"));
var form_1 = require("../../../context/form");
var ListComponent = function () {
    var files = (0, form_1.useFormContext)().files;
    return (react_1.default.createElement(List_1.default, { disablePadding: true }, files === null || files === void 0 ? void 0 : files.map(function (file, index) { return (react_1.default.createElement(Item_1.default, { file: file, index: index, key: file.size })); })));
};
exports.default = ListComponent;
